import React, { Component } from 'react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Theme from 'Theme';
import UserLogin from 'modules/Users/containers/UserLogin';
import { Logo } from 'components';
import { Label } from 'reactstrap';
class Login extends Component {
    render() {
        return (React.createElement(Wrapper, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                } },
                React.createElement("img", { src: '/logo_ticando.svg', height: '60px', width: '240px', alt: 'img ticando', style: {
                        marginLeft: 0,
                        marginRight: 0,
                        marginTop: '25px',
                    } })),
            React.createElement(Label, { style: {
                    marginBottom: 0,
                    color: Theme.color.secondary,
                    width: '100%',
                    textAlign: 'center',
                    paddingTop: Theme.size.space[1],
                } }, `${process.env.REACT_APP_VERSION}`),
            React.createElement(Label, { size: '10', style: {
                    marginTop: 0,
                    color: Theme.color.secondary,
                    width: '100%',
                    textAlign: 'center',
                    paddingTop: Theme.size.space[1],
                } }, `${process.env.REACT_APP_DATEBUILD}`),
            React.createElement(UserLogin, null)));
    }
}
export default Login;
const Wrapper = cxs('div')({
    boxShadow: `0 0 100px -20px ${opacity(0.25, Theme.color.primary)}`,
    margin: 'auto',
    borderWidth: `${Theme.size.hairline}`,
    borderColor: Theme.color.hairline,
    borderRadius: '5px',
    borderStyle: 'solid',
});
const StyledLogo = cxs(Logo)({
    margin: `${Theme.size.space[4]} ${Theme.size.space[4]} 0 ${Theme.size.space[4]}`,
});



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Login.tsx
// module id = 576
// module chunks = 0